var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquares3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C8.89543 2 8 2.89543 8 4V6.5H14C15.933 6.5 17.5 8.067 17.5 10V16H20C21.1046 16 22 15.1046 22 14V4C22 2.89543 21.1046 2 20 2H10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H14C15.1046 8 16 8.89543 16 10V20C16 21.1046 15.1046 22 14 22H4C2.89543 22 2 21.1046 2 20V10C2 8.89543 2.89543 8 4 8ZM9 10.5C8.86709 10.5 8.73419 10.5344 8.6151 10.6031L5.3849 12.4682C5.14672 12.6057 5 12.8599 5 13.1349V16.8651C5 17.1401 5.14672 17.3943 5.3849 17.5318L8.6151 19.3969C8.85328 19.5344 9.14672 19.5344 9.3849 19.3969L12.6151 17.5318C12.8533 17.3943 13 17.1401 13 16.8651V13.1349C13 12.8599 12.8533 12.6057 12.6151 12.4682L9.3849 10.6031C9.26581 10.5344 9.13291 10.5 9 10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares3);
export default __webpack_public_path__ + "static/media/squares-3.e21e065e659c54faaee287ce77a08605.svg";
export { ForwardRef as ReactComponent };